export const manageTagsSentResponse = ({ response, setTagSuggestions }) => {
  // console.log(response);
  if (response?.action_code === "tags_sent") {
    const tagsDataResponse = response?.payload;
    if (tagsDataResponse) {
      const { tag_suggestions = [] } = tagsDataResponse;
      setTagSuggestions(Array.isArray(tag_suggestions) ? tag_suggestions : []);
    }
  }
};
